export default __webpack_public_path__ + "media/Desire-2.23c45ecd.svg";